import { Trash2 } from "lucide-react";

export default function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12"
      data-testid={testid}
    >
      <div>
        <h1 className="font-display text-5xl md:text-6xl mb-3">{title}</h1>
        {subtitle && <p className="text-muted max-w-2xl font-body">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ children, icon: Icon }) {
  return (
    <div className="glass-card rounded-md empty-state">
      {Icon && (
        <div className="empty-state-icon" aria-hidden="true">
          <Icon className="w-16 h-16 md:w-20 md:h-20" strokeWidth={1.2} />
        </div>
      )}
      <div className="empty-state-text">{children}</div>
    </div>
  );
}

export function ItemRow({ children, onDelete, testid }) {
  return (
    <div
      className="glass-card rounded-md p-6 flex items-center justify-between gap-4 hover:border-gold-subtle transition group"
      data-testid={testid}
    >
      <div className="flex-1 min-w-0">{children}</div>
      {onDelete && (
        <button
          onClick={onDelete}
          className="text-faded hover:text-red-400 transition opacity-0 group-hover:opacity-100"
          data-testid={`${testid}-delete`}
        >
          <Trash2 className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
